<template>
  <div id="main">
    <Card class="widget-maxheight-fullheight ivu-card-head">
      <div slot="title">
        <h4 class="font-weight-bold">Dashboard</h4>
      </div>
      <Icon class="ico mx-3" type="ios-settings" color="white" size="10px" title="Event App Settings"
            @click.native="openEventSettings">
      </Icon>
      <EventAppSettings ref="eventAppSettings"></EventAppSettings>
    </Card>
    <row class="row1">

      <i-col :xs="24" :sm="24" :md="8" :lg="8">
        <Spin size="large" fix v-if="spinEvent"></Spin>
        <Card class="child colm-r1 m-1" v-model="items">
          <div slot="title" align="center" class="k4-cardTitle">
            ABOUT THE EVENT

            <i href="#">
              <Tooltip content="This widget allows you refresh the data"
                      transfer
                      placement="bottom"
                      max-width="150">
                <Icon class="ico" type="md-sync"
                      @click="getCurrEvent()"></Icon>
              </Tooltip>
            </i>
          </div>
          <Page show-total v-show="showTags && licenses != 0" :total="dataCount" :page-size="pageSize"
                class="k4-aboutTheEvent__page p-2"
                show-sizer :page-size-opts="pageSizer" transfer size="small"
                @on-change="changeSelectedPage" @on-page-size-change="changePageSize">
          </Page>
          <table v-show="licenses != 0" class="t02 p-0" width="97%" align="center">
            <tr width="100%" v-for="(license, index) in licenses">
              <div class="k4-aboutTheEvent__licenseInfo tableEvent py-1 text-center text-gray">
                <div>
                  <span title="license label" class="text-black">{{license.licenseLabel}}</span>
                  <span title="license key"> | <b>{{license.licenseKey}}</b></span>
                  <span title="leads collected"> | {{numLeads[index]}} leads</span>
                </div>
                <div>
                  Recent login: {{license.updatedDate}}
                </div>
              </div>
              <td width="35%" class="tableEvent px-1">
                <div class="d-flex justify-content-around align-items-center">
                  <Icon class="ico" title="copy" type="md-copy" v-on:click="copyKey(license.licenseKey)" size="20"/>
                  <Icon v-if="license.deviceType == 'ios' && license.isUsed" class="ico k4-deviceIcon" type="logo-apple"
                        title="Being used by an ios" size="20"/>
                  <Icon v-if="license.deviceType == 'android' && license.isUsed" class="ico k4-deviceIcon" type="logo-android"
                        title="Being used by an android" size="20"/>
                  <Icon v-if="license.deviceType == 'desktop' && license.isUsed" class="ico k4-deviceIcon" type="ios-laptop"
                        title="Being used by desktop" size="20"/>
                  <Icon v-if="(license.deviceType == null || license.deviceType == '') && license.isUsed"
                        class="ico k4-deviceIcon" type="ios-laptop"
                        title="Being used by desktop" size="20"/>
                  <Icon v-if="(license.deviceType == null || license.deviceType == '') && !license.isUsed" class="k4-deviceIcon"
                        style="color: white; font-size: 1.1vw;"
                        type="ios-laptop" size="20"/>
                  <Poptip
                    confirm
                    title="This will logout license key to the mobile app."
                    transfer
                    @on-ok="ok(license.licenseKey)"
                    @on-cancel=""
                    ok-text="Continue"
                    padding="0 0"
                    word-wrap width="200">
                    <Icon class="ico k4-logOut" v-if="license.isUsed" title="logout" type="ios-log-out" size="20"/>
                    <Icon class="k4-logOut" v-else style="color: white; font-size: 1.1vw;" type="ios-log-out" size="20"/>
                  </Poptip>
                </div>
              </td>
            </tr>
          </table>
          <div v-show="!showTags"
               style="padding-top: 8vw;font-style: italic;height: 100%;position:relative;display:flex;align-items:center;justify-content:center">
            <p v-show="role == 'admin'" style="color: dimgrey;margin: 0; text-align: center; font-size: 0.8vw">
              Select an event and company to view the licenses</p>
            <p v-show="role != 'admin'" style="color: dimgrey;margin: 0; text-align: center; font-size: 0.8vw">
              Select an event to view the licenses</p>
          </div>
          <div v-show="showTags && licenses == 0"
               style="color: dimgrey;padding-top: 8vw;font-style: italic;height: 100%;position:relative;display:flex;align-items:center;justify-content:center">
            <p style="color: dimgrey;margin: 0; text-align: center; font-size: 0.8vw">No licenses</p>
          </div>
          <br/>
        </Card>
      </i-col>

      <i-col :xs="24" :sm="24" :md="8" :lg="8">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Card class="child colm-r1 m-1">
          <div slot="title" align="center" class="k4-cardTitle">
            HIGH LEVEL METRICS

            <i href="#">
              <Tooltip content="This widget allows you refresh the data"
                      transfer
                      placement="bottom"
                      max-width="150">
                <Icon class="ico" type="md-sync"
                      @click="getMetrics()"></Icon>
              </Tooltip>
            </i>
          </div>

          <table class="t02 m-1" width="95%" align="center">
            <tr width="100%">
              <td width="50%" class="CardMetrics">
                <table width="100%">
                  <tr>
                    <td class="d-flex justify-content-center align-items-center">
                      <div>
                        <img src="@/assets/icons/Group210.png" class="k4-highLevelMetrics__counter__icon"/>
                      </div>
                      <div class="k4-counter px-2">
                        {{leadCnt}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" align="center">
                      <p class="k4-highLevelMetrics__counter__label">PROCESSED LEADS</p>
                    </td>
                  </tr>
                </table>
              </td>

              <td width="50%" class="CardMetrics">
                <table width="100%">
                  <tr>
                    <td class="d-flex justify-content-center align-items-center">
                      <div>
                        <img src="@/assets/icons/QRCODE.png" class="k4-highLevelMetrics__counter__icon">
                      </div>
                      <div class="k4-counter px-2">
                        {{surveyCnt}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" align="center">
                      <p class="k4-highLevelMetrics__counter__label">PROCESSED QUESTIONNAIRES</p>
                    </td>
                  </tr>
                </table>
              </td>

            </tr>
          </table>
          <table width="100%">
            <tr width="100%">
              <td class="cntFont" width="33%" align="center" style="color: red;">{{hot}}</td>
              <td class="cntFont" width="33%" align="center" style="color: darkorange;">{{warm}}</td>
              <td class="cntFont" width="33%" align="center" style="color: #0099cc;">{{cold}}</td>
            </tr>
            <tr width="100%">
              <td width="33%" align="center">
                <div align="center" class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/icons/hot.png" style="height: 1.97vw;" class="mx-2">
                  <div style="font-size: 1.05vw;">Hot</div>
                </div>
              </td>
              <td width="33%" align="center">
                <div align="center" class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/icons/warm.png"
                       style="height: 1.97vw;" class="mx-2">
                  <div style="font-size: 1.05vw;">Warm</div>
                </div>
              </td>
              <td width="33%" align="center">
                <div align="center" class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/icons/cold.png"
                       style="height: 1.97vw;" class="mx-2">
                  <div style="font-size: 1.05vw;">Cold</div>
                </div>
              </td>
            </tr>
          </table>
        </Card>
      </i-col>

      <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-right: 0;">
        <Card class="child colm-r1 m-1">
          <div slot="title" align="center" class="k4-cardTitle">
            % LEADS/QUESTIONNAIRE
          </div>
          <div id="content" class="pt-1">
            <Card3 :chartData="percentileChart" style="height: 16.5vw;"></Card3>
          </div>
        </Card>
      </i-col>
    </row>

    <row class="row1 row2">
      <i-col :xs="24" :sm="24" :md="16" :lg="16" style="padding: 0.5vw 0.5vw 0 0;">
        <Card class="child colm-r2">
          <div slot="title" align="center" class="k4-cardTitle">
            DAILY HISTORY
          </div>
          <div id="dailyHistory">
            <Card4 :chartData="dailyHistoryChart" :max="max" :size="size" style="height: 14.5vw;"></Card4>
          </div>
        </Card>
      </i-col>
      <!--      <i-col :xs="24" :sm="24" :md="8" :lg="8"-->
      <!--             style="padding: 0.5vw 0 0 0.5vw">-->
      <!--        <Card class="child colm-r2">-->
      <!--          <div slot="title" align="center" style="font-size: 0.8vw">-->
      <!--            LEADS PER SALE-->
      <!--          </div>-->
      <!--          <div class="leadPerKey" align="center">-->
      <!--            <Card5 :chartData="leadsPerSale" style="height: 18vw;"></Card5>-->
      <!--          </div>-->
      <!--          <div id="pie_legend" class="chart-legend"></div>-->
      <!--        </Card>-->
      <!--      </i-col>-->
      <i-col :xs="24" :sm="24" :md="8" :lg="8" span="7"
             style="padding-top: 0.5vw; padding-bottom: 0; padding-right: 0; padding-left: 0.5vw;">
        <Card class="child colm-r2">
          <div slot="title" align="center" class="k4-cardTitle">
            LEADS PER SALE
          </div>
          <div class="chart pt-1" style="width: 100%;">
            <canvas id="chartC5" ref="myChart" class="pie" width="10%" height="5%"></canvas>
          </div>
          <!--          <div id = "pie_legend" class = "chart-legend"></div>-->
        </Card>
      </i-col>
    </row>

  </div>
</template>


<script>
  import Card3 from './Card3.vue'
  import Card4 from './Card4.vue'
  import Card5 from './Card5.vue'
  import {getLeadFormByEvent, getLevelMetrics} from '../../services/Forms.service'
  import {getLeadForms, getLeadsProcessed} from '../../services/LeadForms.service'
  import {getEventById} from '../../services/Events.service'
  import {getSurveyForms} from '../../services/SurveyForms.service'
  import {licenseLogout} from '../../services/Authentication.service'
  import {getSalesReps} from '../../services/SalesRep.service'
  import {getLicenses} from '../../services/Licenses.service'
  import {getLeads} from '../../services/Leads.service'
  import EventAppSettings from './EventAppSettings'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'
  import moment from 'moment-timezone'

  export default {
    name: 'MainCard',
    components: {
      EventAppSettings,
      Card3,
      Card4,
      Card5
    },
    data() {
      return {
        role: '',
        eventName: '',
        companyName: '',
        items: [],
        licenses: [],
        leadCnt: 0,
        surveyCnt: 0,
        hot: 0,
        warm: 0,
        cold: 0,
        spinShow: true,
        spinEvent: true,
        percentile: 0,
        datasets: [],
        datasetsC4: {},
        datasetsC5: {},
        leadForms: [],
        timer: '',
        max: 0,
        size: 3,
        dataCount: 0,
        pageSizer: [5, 10, 15, 20, 30],
        pageSize: 20,
        historyData: [],
        numLeads: []
      }
    },
    watch: {
      // leadForms(items) {
      //   this.getDailyHistory(items);
      // }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
      showTags() {
        if ((!this.eventName || this.eventName != 'N/A') && (!this.companyName || this.companyName != 'N/A')) {
          return true;
        } else return false;
      },
      percentileChart() {
        return {
          datasets: [{
            data: [this.percentile],
            datalabels: {
              align: 'center',
              anchor: 'center'
            },
            backgroundColor: [
              '#F0C102'
            ]
          }]
        }
      },
      dailyHistoryChart() {
        return (this.datasetsC4);
      },
      leadsPerSale() {
        return (this.datasetsC5);
      }

    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      openEventSettings: function () {
        this.$refs.eventAppSettings.setValues();
        // this.$refs.eventAppSettings.openConfigForm('Event App Settings');
      },

      getCurrEvent: function () {
        const self = this;
        this.spinEvent = true;
        this.eventName = 'N/A';
        this.companyName = 'N/A';
        this.leadForms = 0;
        this.licenses = [];
        this.items = [];
        this.items.startDate = moment(new Date()).format('dddd, MMMM DD, YYYY');
        this.items.endDate = moment(new Date()).format('dddd, MMMM DD, YYYY');
        let companies = JSON.parse(localStorage.getItem('companies'));
        let eventsList = JSON.parse(localStorage.getItem('events'));
        if (companies && eventsList) {
          let company = companies.filter(a => a.companyName === sessionStorage.getItem('companyName'));
          let event = eventsList.filter(a => a.eventName === sessionStorage.getItem('eventName') && a.deleted == false);
          if ((company.length > 0 && event.length > 0) && (company[0].companyId != 0 && event[0].eventId != 0)) {
            this.companyName = company[0].companyName;
            this.eventName = event[0].eventName;
            this.items.startDate = moment(event[0].startDate).format('dddd, MMMM DD, YYYY');
            this.items.endDate = moment(event[0].endDate).format('dddd, MMMM DD, YYYY');
            let eventId = event[0].eventId;
            getLicenses(false, company[0].companyId)
              .then(lic => {
                this.licenses = lic.data.filter(b => b.eventId === eventId);
                this.licenses.updatedDate = lic.data.map(c => c.updatedDate = moment(c.updatedDate).format('MMMM DD, YYYY, hh:mm:ss'));
                this.licenses.sort((a, b) => (a.licenseKey > b.licenseKey) ? 1 : ((b.licenseKey > a.licenseKey) ? -1 : 0))
                  .sort((a, b) => (a.isUsed < b.isUsed) ? 1 : ((b.isUsed < a.isUsed) ? -1 : 0))
                  .sort((a, b) => (a.deviceType < b.deviceType) ? 1 : ((b.deviceType < a.deviceType) ? -1 : 0));


                this.historyData = this.licenses;
                this.dataCount = this.licenses.length;
                if (this.historyData.length < this.pageSize) {
                  this.licenses = this.historyData;
                } else {
                  this.licenses = this.historyData.slice(0, this.pageSize);
                }
                /////get leadForms
                getLeadsProcessed(false, company[0].companyId, eventId).then(leadForm => {
                  for (let license in self.licenses) {
                    var a = leadForm.data.filter(a => a.createdBy === self.licenses[license].licenseKey);
                    self.numLeads.push(a.length);
                  }
                });
                this.spinEvent = false;
              });
          } else {
            this.spinEvent = false;
          }
        } else {
          this.spinEvent = false;
        }
      },
      changePageSize(size) {
        this.pageSize = size;
        this.changeSelectedPage(1);
      },
      changeSelectedPage(index) {
        let _start = (index - 1) * this.pageSize;
        let _end = index * this.pageSize;
        this.licenses = this.historyData.slice(_start, _end);
      },
      copyKey: function (data) {
        const el = document.createElement('textarea');
        el.value = data;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      },
      ok(licenseKey) {
        licenseLogout(licenseKey).then((response) => {
          if (response.status == 200) {
            this.$Message.success('Logged out to mobile app.');
            this.getCurrEvent();
          }
        }).catch(error => {
          this.$Message.info('License key is currently not in use...');
        });
      },
      getMetrics: function () {
        const self = this;
        self.spinShow = true;
        let companies = JSON.parse(localStorage.getItem('companies'));
        let eventsList = JSON.parse(localStorage.getItem('events'));
        if (companies && eventsList) {
          let company = companies.filter(a => a.companyName == sessionStorage.getItem('companyName'));
          let event = eventsList.filter(a => a.eventName == sessionStorage.getItem('eventName'));
          if ((company.length > 0 && event.length > 0) && (company[0].companyId != 0 && event[0].eventId != 0)) {
            let companyId = company[0].companyId;
            let eventId = event[0].eventId;
            getLevelMetrics(companyId, eventId, false).then(response => {
              self.leadCnt = response.data.processedLeads;
              self.surveyCnt = response.data.processedQuestionnaires;
              self.hot = response.data.hotLeads;
              self.warm = response.data.warmLeads;
              self.cold = response.data.coldLeads;
              self.percentile = response.data.average;
              self.spinShow = false;
            });
          } else self.spinShow = false;
        } else self.spinShow = false;
      },
      getDailyHistory() {
        const self = this;
        let users = [];
        let keys = [];
        let eventDays = [];
        let labels = [];
        let dataset = [];
        let cnt = 0;
        let colorlib = [
          '#1ab2ff',
          '#FA0303',
          '#00e6b8',
          '#ffff00',
          '#003366',
          '#ff3399',
          '#ff5500',
          '#00652C',
          '#00ffff',
          '#ff9999',
          '#ffcc00',
          '#00ff99',
          '#99ccff',
          '#ff9933',
          '#800080',
          '#90ffbb',
          '#000b80',
          '#ff2f00',
          '#ffbbee',
          '#ff00aa',
          '#006ccc',
          '#000eef',
          '#ff0b00',

        ];
        let sums = [];
        let colorsC5 = [];
        let datasetsC5 = []

        let leadFrms = [];
        let formId = 0;

        let companies = JSON.parse(localStorage.getItem('companies'));
        let eventsList = JSON.parse(localStorage.getItem('events'));
        if (companies && eventsList) {
          let company = companies.filter(a => a.companyName === sessionStorage.getItem('companyName'));
          let event = eventsList.filter(a => a.eventName === sessionStorage.getItem('eventName'));
          if ((company.length > 0 && event.length > 0) && (company[0].companyId != 0 && event[0].eventId != 0)) {
            let companyId = company[0].companyId;
            let eventId = event[0].eventId;

            ///////////// GET USERS
            getLicenses(false, companyId).then(lic => {
              // users = lic.data.map(a => a.licenseLabel);
              keys = lic.data.filter(a => a.eventId === eventId).map(a => a.licenseKey);
              ///////////// GET EVENT DAYS
              getEventById(eventId).then(event => {
                let startDay = event.data.startDate;
                let endDay = event.data.endDate;
                for (var day = new Date(startDay); day <= new Date(endDay); day.setDate(day.getDate() + 1)) {
                  eventDays.push(moment(day).format('dddd, MMMM DD, YYYY'));
                  ++cnt;
                  labels[cnt - 1] = 'Day ' + cnt;
                }

                //////////// GET LEADFORMS
                getLeadFormByEvent(eventId).then(response => {
                  if (response.data != null || response.data != '') {
                    formId = response.data.formId;
                    getLeadsProcessed(false, companyId, eventId).then(processed => {
                      leadFrms = processed.data;


                      let data = self.create2DArr(keys.length, eventDays.length);
                      for (let key in keys) {
                        let sum = 0;
                        for (let date in eventDays) {
                          let count = leadFrms.filter(function (frm) {
                            let i = moment(frm.createdDate).format('dddd, MMMM DD, YYYY');
                            return (i === eventDays[date] && frm.createdBy === keys[key]);
                          }).length;
                          self.max = self.max < count ? count : self.max;
                          self.size = self.max === 0 ? 3 : Math.round(self.max / 3);
                          count = count == null ? 0 : count;
                          data[key][date] = count;
                          sum += count;
                        }
                        sums.push(sum);
                      }
                      // Create dataset object

                      var x = keys.length;
                      for (var n = 0; n < x; n++) {
                        dataset.push({
                          label: keys[n],
                          data: data[n],
                          backgroundColor: colorlib[n]
                        });
                        colorsC5.push(colorlib[n]);

                      }
                      self.datasetsC4 = {
                        labels: eventDays,
                        datasets: dataset
                      };
                      self.datasetsC5 = {
                        labels: keys,
                        datasets: [{
                          label: 'No. of Leads',
                          data: sums,
                          backgroundColor: colorsC5,
                          hoverBackgroundColor: colorsC5
                        }]
                      };
                      if (keys.length > 0) {
                        this.getLeadSale(self.datasetsC5);
                      }
                    });
                  }
                });
              });
            });
          }
        }
      },
      create2DArr: function (numRows, numColumns) {
        let array = new Array(numRows);

        for (let i = 0; i < numRows; i++) {
          array[i] = new Array(numColumns);
        }
        return array;
      },
      getLeadSale: function (dataC5) {
        const self = this;
        var data = {
          labels: [
            "Red",
            "Blue",
            "Yellow"
          ],
          datasets: [{
            data: [300, 50, 100],
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56"
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56"
            ],
            borderWidth: 1
          }]
        };

        var options = {
          animation: {
            animateRotate: true,
            animateScale: true,

          },
          legend: {
            display: true,
            position: 'right',
            usePointStyle: true,
            fontSize: 5
          },
          legendCallback: function (chart) {
            var text = [];
            text.push('<ul class="' + chart.id + '-legend">');
            for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
              text.push('<li><span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '">');
              if (chart.data.labels[i]) {
                text.push(chart.data.labels[i]);
              }
              text.push('</span></li>');
            }
            text.push('</ul>');
            return text.join("");
          },
          drawBorder: false,
          cutoutPercentage: 60,
          tooltips: {
            custom: function (tooltip) {
              //tooltip.x = 0;
              //tooltip.y = 0;
            },
            mode: 'single',
            callbacks: {
              label: function (tooltipItems, data) {
                var sum = data.datasets[0].data.reduce(add, 0);

                function add(a, b) {
                  return a + b;
                }

                return parseInt((data.datasets[0].data[tooltipItems.index] / sum * 100), 10) + ' %';
              },
              beforeLabel: function (tooltipItems, data) {
                return data.labels[tooltipItems.index] + "\n" + data.datasets[0].data[tooltipItems.index] + ' leads';
              }
            }
          }
        };

        // var chart = this.$refs.myChart;
        var ctx = document.getElementById('chartC5');
        var myChart = new Chart(ctx, {
          type: 'doughnut',
          data: dataC5,
          options: options
        });


// Note - tooltipTemplate is for the string that shows in the tooltip

// legendTemplate is if you want to generate an HTML legend for the chart and use somewhere else on the page

// e.g:

        // document.getElementById('pie_legend').innerHTML = myChart.generateLegend();
      }
    },
    created() {
      setTimeout(function () {
        let elements = document.getElementsByClassName('child');
        for (let i = 0; i < elements.length; i++) {
          elements[i].children[0].style.backgroundColor = '#d3d5d7';
          elements[i].children[0].style.color = '#000000';
        }
      }, 50);
      this.role = localStorage.getItem('role');
      this.getCurrEvent();
      this.getMetrics();
      this.getDailyHistory();
      this.timer = setInterval(this.getCurrEvent, 40000);
      this.timer = setInterval(this.getMetrics, 60000);
      this.hot = 0;
      this.warm = 0;
      this.cold = 0;
      this.$Spin.hide();
    },
    mounted() {
      bus.$on('getEvtName', (eventName) => {
        // sessionStorage.setItem('eventName', eventName);
        this.getCurrEvent();
        this.getMetrics();
        this.getDailyHistory();
      });
      bus.$on('getCmpName', (companyName) => {
        // sessionStorage.setItem('companyName', companyName);
        this.getCurrEvent();
        this.getMetrics();
        this.getDailyHistory();
      });
    },
    destroy() {
      clearInterval(this.timer);
      this.eventName = localStorage.getItem('selected_event');
      this.items = [];
      this.licenses = [];
      this.eventId = '';
      this.leadCnt = 0;
      this.hot = 0;
      this.warm = 0;
      this.cold = 0;
      this.spinShow = true;
      this.percentile = 0;
      this.datasets = [];
    },
  }
</script>

<style scoped>
  .k4-counter {
    font-size: 4em;
  }
  .k4-aboutTheEvent__licenseInfo {
    font-size: 0.8em;
  }
  .k4-cardTitle, .k4-aboutTheEvent__page {
    font-size: 0.9em;
  }
  .k4-highLevelMetrics__counter__icon {
    max-width: 100%;
  }
  .k4-highLevelMetrics__counter__label {
    font-size: 0.95em; 
    text-align: center; 
    width: 90%; 
    color: var(--gray);
  }
  .k4-deviceIcon {
    pointer-events: none;
  }
  .k4-logOut:hover {
    color: var(--danger);
  }
  .ivu-tooltip {
    color: #fff;
    border: 1px solid #fff;
    border-radius: 2px;
    margin: 0 auto;
    padding: 0.5%;
    text-align: center;
  }

  .hTitle {
    padding-top: 0.4vw;
    text-align: center;
    color: #001924;
    text-transform: uppercase;
    font-size: 1.4vw;
  }

  .divData {
    border: 1px solid darkgrey;
    width: 93%;
    border-radius: 5px;
    font-size: 0.7vw;
    color: #454c5b
  }

  .row1 {
    padding-top: 0.8vw;
    padding-bottom: 0vw;
    margin: 0;
    width: inherit;
    border-spacing: 0;
  }

  .row2 {
    padding-top: 0vw;
    padding-bottom: 0vw;
  }

  .colm-r1 {
    height: 21.13vw;
    overflow: auto;
  }

  .colm-r2 {
    height: 18vw;
  }

  .tableEvent {
    border: 0.5px solid darkgray;
    border-spacing: 0px;
    padding-top: 1%;
    padding-bottom: 1%;
    overflow: auto;
    font-size: 0.75vw;
  }

  table.t02 tr:first-child td:first-child {
    border-top-left-radius: 7px;
  }

  table.t02 tr:first-child td:last-child {
    border-top-right-radius: 7px;
  }

  table.t02 tr:last-child td:first-child {
    border-bottom-left-radius: 7px;
  }

  table.t02 tr:last-child td:last-child {
    border-bottom-right-radius: 7px;
  }

  .ico {
    font-size: 1.1vw;
  }

  .ico:hover {
    cursor: pointer;
  }

  .ico:active {
    opacity: 0.7;
    transform: translateY(1px);
  }

  .CardMetrics {
    text-align: center;
    border: 0.5px solid darkgray;
    /*border-collapse: collapse;*/
    border-spacing: 0px;
    padding-top: 2%;
    padding-bottom: 1%;
    overflow: auto;
    font-size: 0.75vw;
  }

  .frmCnt {
    top: 17%;
    width: 90%;
    height: 40%;
    position: absolute;
    border: 1px solid #404040;
    margin: auto;
    padding: 0;
    right: 0;
    left: 0;
    border-radius: 10px;
  }

  .childDiv {
    padding: 0;
    margin: 0;
    width: 50%;
    height: 100%;
  }

  .cntFont {
    font-family: 'Arimo', sans-serif;
    font-size: 4vw;
  }

  #content {
    margin: auto;
    width: content-box;
    height: fit-content;
    background-color: #FFFFFF;
    padding: 10px;
  }

  #dailyHistory {
    margin: auto;
    width: content-box;
    background-color: #FFFFFF;
    padding: 10px;
    height: 100px;
  }

  #leadPerKey {
    margin: auto;
    width: content-box;
    height: content-box;
    background-color: #FFFFFF;
    padding: 10px;
    align-items: center;
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  li {
    display: inline-table;
  }

  .pie-legend {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .pie-legend span {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    margin-right: 16px;
    margin-bottom: -2px;
  }

  .pie-legend li {
    margin-bottom: 10px;
    display: inline-block;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/a_generalDashboard/MainCard.vue